<template>
    <div>
        <van-popup v-model="showFrame" :style="{ width: '90%' }" :close-on-click-overlay="false">
        <div class="pop-box">
        <p style="text-align:center;">注册服务条款</p>
        <pre>

版本生效日期：2019年6月

欢迎您与“慕渊（上海）智能科技有限公司”（下称“慕渊”）共同签署本《注册服务条款》协议（下称“本协议”），本协议阐述之条款和条件适用于您使用慕渊基于互联网，已包含慕渊展商秀官方网站（www.zhanshangxiu.com）、展商秀微信端及展商秀服务市场等在内的各种形态（包括未来技术发展出现的新的服务形态）向您提供的各项服务。

一、法律声明

1、展商秀服务的所有权和运营权归慕渊（上海）智能科技有限公司所有。所提供的服务必须按照其发布的公司章程，服务条款和操作规则严格执行。用户通过完成注册程序并点击一下“我已阅读并同意”的按钮，这表示 用户与慕渊（上海）智能科技有限公司达成本协议并接受所有的服务条款。
2、您在点击同意本协议之前，应当认真阅读本协议。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。
3、当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序，或以任何方式进入慕渊展商秀官方网站并使用服务即表示您已充分阅读、理解并同意接受本协议的条款和条件。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序并停止使用服务。
二、定义

2.1慕渊：指慕渊（上海）智能科技有限公司，以及关联企业上海联展软件技术有限公司、上海悠逸信息技术有限公司等企业。上海联展软件技术有限公司为本网站注册公司，慕渊（上海）智能科技有限公司为本网站实际经营者。
2.2慕渊服务：展商秀、招展通、展小哥、会展人、联展、悠逸
三、隐私政策

【特别提示】请您在使用我们提供的各项产品\服务前，仔细阅读并充分理解本《隐私政策》（重点内容我们已将字体加粗请您特别关注）并作出相应选择。一旦您使用或继续使用我们的产品\服务时，即意味着您同意我们按照本隐私政策处理您的相关信息。
慕渊非常重视用户个人信息（即能够独立或与其他信息结合后识别用户身份的信息）的保护，在您使用慕渊提供的服务时，您同意慕渊按照在慕渊中国站上公布的隐私政策收集、存储、使用、披露和保护您的个人信息。慕渊希望通过隐私政策向您清楚地介绍慕渊对您个人信息的处理方式，因此慕渊建议您完整地阅读隐私政策，以帮助您更好地保护您的隐私权。
1、我们如何收集和使用您的个人信息
我们会遵循正当、合法、必要的原则，出于本政策所述的以下目的，收集和使用您在使用服务过程中主动提供或产生的企业、个人信息:帮助您成为我们的用户，向您提供产品\服务，为您优化用户体验，为您提供安全保障:
2、我们在您使用服务过程中可能直接或间接收集的个人信息
为了满足法律法规及提供服务的基本要求，保障您的账号安全与系统运行安全，我们会收集您在使用我们服务过程中产生的相关信息，包括但不限于：个人信息、日志信息、位置信息、设备信息、订单信息、支付信息等；如果您愿意额外补充如下个人信息，将更有助于我们向您提供更为个性化的服务：包括您的性别、年龄、职业、喜好等。如果您不提供该等信息，不会影响您享受服务的基本功能。
3、为您提供安全保障
为提高您使用我们提供的服务的安全性，更准确地预防钓鱼网站欺诈和木马病毒，我们可能会使用或整合您的个人信息以及我们的关联方、合作伙伴取得您授权或者依法共享的信息，根据您的使用习惯和常用软件信息等来综合判断您的账号及交易风险，包括验证身份，预防、发现、调查可能存在的欺诈、网络病毒、网络攻击等安全风险以及违反我们或关联方协议、政策或规则等行为，以保护您、其他用户、我们或关联方的合法权益，并记录一些我们认为有风险的链接(“URL”)。
4、请您知悉，以下情形中，我们收集、使用个人信息无需征得您的授权同意：
4.1 与国家安全、国防安全有关的；
4.2 与公共安全、公共卫生、重大公共利益有关的；
4.3 与犯罪侦查、起诉、审判和判决执行等有关的；
4.4 出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
4.5 所收集的个人信息是个人信息主体自行向社会公众公开的；
4.6 从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
4.7 根据您的要求签订合同所必需的；
4.8 用于维护所提供的产品与/或服务的安全稳定运行所必需的，例如发现、处置产品与/或服务的故障；
4.9 为合法的新闻报道所必需的；
4.10 学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
4.11法律法规规定的其他情形。
          </pre>
        <p style="text-align: center;">
            <van-button type="info" size="small" @click="agree">同意条款</van-button>
        </p>
      </div>
    </van-popup>
    </div>
</template>
<script>
export default {
    props:['showFrame'],
    methods:{
        agree(){
          this.$emit('agree')
        }
    },
}
</script>
<style lang="scss" scoped>
.pop-box {
  background: #fff;
  padding: 20px;
  height: 100%;
  overflow-y: auto;
      height: 500px;  
}
pre{
    white-space: pre-wrap;
    word-wrap: break-word;
    text-align: justify;
}
</style>